<template>
  <div class="product">
    <banner title="产品中心" :img="innerBanner" />
    <div class="product-content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane :label="item.label" :name="item.name" v-for="item in productList" :key="item.name">
          <div class="product-list">
            <div class="img-item" v-for="item1 in item.list" :key="item1.title">
              <a :title="item1.title" @click="gotoDetail({name:item.name,title:item1.title})">
                <div class="img"><img :src="item1.img" :alt="item1.title"></div>
                <div class="con">
                  <h4>{{ item1.title }}</h4>
                  <p>关注人数：<b>{{ item1.number }}</b>位客户</p>
                  <div class="more"></div>
                </div>
              </a>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import {productList} from "@/config.js"
import innerBanner from "@/assets/img/case/inner-banner.jpg"
export default {
  data() {
    return {
      innerBanner,
      activeName: "实验台",
      productList,
    };
  },
  components: {
    Banner
  },
  methods:{
    gotoDetail(item){
      this.$router.push({
        name:"productdetails",
        params:item
      })
    }
  },
  created() {
    if (this.$route.params && this.$route.params.title) {
      this.activeName = this.productList.filter(item =>
        item.name == this.$route.params.title
      )[0].name
    }
    /* this.$http
      .get(
        "DataDictionary/GetDataDictionaryAll?key=%E4%BA%A7%E5%93%81%E8%A7%86%E9%A2%91%E9%93%BE%E6%8E%A5"
      )
      .then(response => {
        this.videoSrc = response.data[0].Content;
        window.console.log(this.videoSrc);
        this.loading = false;
      })
      .catch(function(error) {
        window.console.log(error);
      }); */
  }
};
</script>

<style lang="scss" scoped>
//公共样式
.title,
.eTitle {
  font-size: 34px;
  font-weight: 400;
  color: #333;
  text-align: center;
}

.eTitle {
  font-size: 30px;
  padding: 10px 0;
}

.product-content {
  padding: 15px 20px;
}

.product-list {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}

.img-item {
  background: #fff;
  margin: 15px 0;
  box-shadow: 0 22px 40px rgba(0, 0, 0, .16);
  width: 24%;
  height: 400px;

  .img {
    overflow: hidden;
    position: relative;
    height: 300px;
  }
}

.img-item:hover {}

.img-item a {
  display: block;
  overflow: hidden;
}

a {
  text-decoration: none;
  color: #333;
  transition: all 0.3s;
}



/* .img-item .img:before {
  position: absolute;
  content: "";
  z-index: 2;
  display: block;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border: 1px solid #fff;
  transition: all .3s ease-in-out 0s;
  opacity: 0;
} */

.img img {
  -webkit-transition: all .6s;
  -moz-transition: all .6s;
  -ms-transition: all .6s;
  -o-transition: all .6s;
  transition: all .6s;
  width: 100%;
  height: 100%;
}

.img-item .con {
  padding: 15px;
  position: relative;
}

.img-item .con h4 {
  position: relative;
  top: 0;
  transition: all .3s ease-in-out 0s;
  margin-bottom: 15px;
  font-size: 15px;
  color: #262626;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.img-item .con p {
  position: relative;
  top: 0;
  font-size: 12px;
  color: #6e6e6e;
  height: 20px;
  transition: all .3s ease-in-out 0s;
  line-height: 20px;
  margin-bottom: 30px;
  margin-top: 12px;
  overflow: hidden;
}

.img-item .con p b {
  color: red;
  padding: 0 2px;
  font-size: 13px;
  font-family: Arial;
}
</style>